import { sagaEffects } from '../../dependencies';

import createFetchExpensesRequest from './createFetchExpensesRequest';

const { all } = sagaEffects;

export default function*() {
    yield all([createFetchExpensesRequest()]);
}
